
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's07292025d584ef0f': `Fermer l'overlay`,
's4bd8b1e7a8147b62': `Retour à la galerie`,
's637376fd03047144': `Image précédente`,
's7ed13ccddb1bf3c3': `Overlay`,
's885970c4ee8d21cc': `Fermer`,
's9475efd7c1377ea0': `Galerie d'images`,
'sb9e59f1e01eb588e': `Ouvrir la galerie d'images`,
'sf592e9ad59fde6e8': `Image suivante`,
    };
  